// libs
import React, { memo, useState } from "react";
import styled from "@emotion/styled";

// analytics
import { onCartClick } from "shared/components/Header/analytics";

// components
import ChunkFallback from "shared/components/ChunkFallback";
import Portal from "shared/components/Portal";

// helpers
import { hideOverflowY } from "shared/helpers/dom";

// constants
import { CHECKOUT_URI } from "shared/constants/uri";

// styles
import { OVERLAY_ZINDEX } from "shared/styles/base";

const Loader = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vw;
    top: 0;
    left: 0;
    z-index: ${OVERLAY_ZINDEX + 10};
    background-color: rgba(0, 0, 0, 0.15);
`;

const CartContainer = styled.div`
    position: relative;
    cursor: pointer;

    .ct-ico {
        font-size: 2rem;
    }

    .ct-cart {
        position: absolute;
        background: #fd7685;
        color: #fff;
        font-weight: 500;
        height: 15px;
        width: 15px;
        border-radius: 50%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        font-size: 14px;
        left: 15px;
    }
`;

interface ICartProps {
    cartCount: number | string;
}

function Cart({ cartCount }: ICartProps) {
    const [showLoader, setShowLoader] = useState(false);

    const goToCart = () => {
        hideOverflowY();
        setShowLoader(true);
        onCartClick();
        window.location.href = CHECKOUT_URI;
    };
    return (
        <>
            <CartContainer role="button" aria-label="cart" onClick={goToCart}>
                <i className="icon-bag ct-ico" />
                <div className="ct-cart">{cartCount}</div>
            </CartContainer>

            {showLoader && (
                <Portal>
                    <Loader>
                        <ChunkFallback />
                    </Loader>
                </Portal>
            )}
        </>
    );
}

export default memo(Cart);
